var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    width: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7a49.7 49.7 0 0 0-4.6.4c-.4.1-.8.4-1.2.8-.4.4-.7.8-.8 1.2L7 11.1a50.3 50.3 0 0 0 .4 7.5c.1.4.4.8.8 1.2.4.4.8.7 1.2.8l1.7.4a49.7 49.7 0 0 0 7.5-.4c.4-.1.8-.4 1.2-.8.4-.4.7-.8.8-1.2l.4-1.7a50 50 0 0 0-.4-7.5c-.1-.4-.4-.8-.8-1.2-.4-.4-.8-.7-1.2-.8L16.9 7H14zm-.6 1.3h.6a49 49 0 0 1 4.1.2c.4.2.6.3.8.6.3.2.4.4.6.8 0 .2.2.6.2 1.3a48.7 48.7 0 0 1-.2 7l-.6.7c-.2.3-.4.4-.8.6-.2 0-.6.2-1.3.2a48.7 48.7 0 0 1-7-.2l-.7-.6c-.3-.2-.4-.4-.6-.8 0-.2-.2-.6-.2-1.3a49 49 0 0 1 .2-7l.6-.7c.2-.3.4-.4.8-.6.2 0 .6-.2 1.3-.2h2.2zm4.3 1.1a.8.8 0 1 0 0 1.7.8.8 0 0 0 0-1.7zm-3.7 1a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2zm0 1.3a2.3 2.3 0 1 1 0 4.6 2.3 2.3 0 0 1 0-4.6z",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "#fdc84a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.a283e1a6.svg";
export { ForwardRef as ReactComponent };